import type { QueryClient } from '@tanstack/react-query';
import { i18n } from '@/shared/i18n';

// Часть строк кабинет получает уже переведёнными сервером: `lang-id` уходит с каждым
// запросом, и по нему бекенд выбирает язык (см. эпик i18n — подпись платёжной системы
// с комиссией, причины трафикбэка в bootstrap, сообщения валидации форм).
//
// Для react-query это обычные данные, о языке он ничего не знает, поэтому после
// переключения языка кабинет отдавал бы их из кеша на прежнем языке — у bootstrap
// staleTime 30 минут, то есть полчаса вперемешку. Инвалидируем всё: язык переключают
// редко, а выборочный список ключей пришлось бы поддерживать вручную.
export function bindLanguageToQueryCache(queryClient: QueryClient): () => void {
  const invalidate = () => {
    void queryClient.invalidateQueries();
  };

  i18n.on('languageChanged', invalidate);

  return () => {
    i18n.off('languageChanged', invalidate);
  };
}
